



































import { filterMixin } from '@/utils/mixins/filterMixin'
import { getClients } from '~/api/Agency/agency.api'
import Autocomplete from '~/components/Autocomplete.vue'
import FlatFilter from '~/components/FlatFilter.vue'
import { Params } from '~/utils/interfaces'

export default filterMixin.extend({
  components: {
    Autocomplete,
    FlatFilter,
  },
  data() {
    return {
      searchTerms: [
        this.$t('identity'),
        this.$t('first_name'),
        this.$t('last_name'),
        this.$t('email'),
        this.$t('phone'),
        this.$t('credit_card'),
      ],
      types: [
        { text: this.$t('DESTINY'), value: 'DESTINY' },
        { text: this.$t('ORIGIN'), value: 'ORIGIN' },
      ],
    }
  },
  methods: {
    async getClients(params?: Params) {
      const response = await getClients({ ...params, type: 'ORIGIN' })
      response.data.results = response.data.results.map(i => ({
        ...i,
        text: `${i.first_name} ${i.last_name}`,
      }))
      return response
    },
  },
})
